import PublicLayout from "@/components/PublicLayout";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { AtSign, Smartphone } from "lucide-react";
// import GoogleSignInButton from "@/components/GoogleSignInButton"; // temporarily disabled
import PasswordInput from "@/components/PasswordInput";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const isEmail = identifier.includes("@");
  const IdIcon = isEmail ? AtSign : Smartphone;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(identifier.trim(), password);
      toast.success(`Welcome back, ${u.full_name?.split(" ")[0] || "user"}!`);
      const to = loc.state?.from || (u.role === "admin" ? "/admin" : "/dashboard");
      nav(to, { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PublicLayout>
      <section className="py-16 gradient-radial-blue">
        <div className="max-w-md mx-auto px-4">
          <div className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
            <div className="section-label">Sign In</div>
            <h1 className="mt-2 font-display font-bold text-3xl text-[#0A192F]">Welcome back</h1>
            <p className="text-sm text-slate-600 mt-1">Sign in with email or mobile.</p>

            <form onSubmit={submit} className="mt-6 space-y-4" data-testid="login-form">
              <div>
                <Label>Email or Mobile</Label>
                <div className="relative">
                  <IdIcon className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                  <Input
                    required
                    value={identifier}
                    onChange={(e) => setIdentifier(e.target.value)}
                    placeholder="name@email.com  or  9876543210"
                    className="pl-9"
                    data-testid="login-identifier"
                  />
                </div>
                <div className="text-xs text-slate-500 mt-1">
                  {identifier ? (isEmail ? "Signing in with email" : "Signing in with mobile number") : "Use either your registered email or mobile"}
                </div>
              </div>
              <div>
                <Label>Password</Label>
                <PasswordInput required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
                <Link to="/forgot-password" className="text-xs text-[#1E3A8A] hover:underline mt-2 inline-block">Forgot password?</Link>
              </div>
              <Button type="submit" disabled={loading} className="w-full bg-[#1E3A8A] hover:bg-[#1E40AF] h-11" data-testid="login-submit-btn">
                {loading ? "Signing in…" : "Sign In"}
              </Button>
            </form>
            <div className="mt-5 text-center text-sm text-slate-600">
              Don't have an account?{" "}
              <Link to="/register" className="text-[#1E3A8A] font-medium hover:underline">Create one</Link>
            </div>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
